class SessionStorageService {
  static setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  static getItem(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  static removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  static clear(): void {
    sessionStorage.clear();
  }
}

export default SessionStorageService;
